import Cookies from 'js-cookie';

// Cookie, які пише скрипт trafficSourceManager (public/index.html).
// Передаються в CRM під тими ж іменами.
const TRAFFIC_SOURCE_COOKIES = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'gclid',
  'gbraid',
  'wbraid',
  'gad_source',
  'gad_campaignid',
  'landing_page',
  'landing_page_referrer',
  'session_start_time_usec',
];

// Cookie сесії GA4 має суфікс measurement id, напр. _ga_SKNH2FRXPH
const GA_SESSION_COOKIE = '_ga_SKNH2FRXPH';
const GA_SESSION_COOKIE_PATTERN = /^_ga_[A-Z0-9]+$/;

// Обидві версії сесійної cookie GA4:
// GS1.2.1756191439.1.0.1744811305.60.0.0        -> 1756191439
// GS2.1.s1782943856$o1$g0$t1782944018$j60$l0$h0 -> 1782943856
const GA_SESSION_ID_PATTERN = /^GS\d+\.\d+\.s?(\d{10})/;

// Коли параметра немає, скрипт пише в cookie рядок 'null'. Натомість
// '(none)' та '(direct)' — значущі значення GA, їх передаємо як є.
const isEmpty = (value?: string): boolean =>
  value === undefined || value === '' || value === 'null';

const getCookie = (name: string): string | undefined => {
  const value: string | undefined = Cookies.get(name);
  return isEmpty(value) ? undefined : value;
};

// GA1.2.297184449.1782943856 -> 297184449.1782943856 (усе після другої точки)
const getGaClientId = (): string | undefined => {
  const parts = (getCookie('_ga') || '').split('.');
  return parts.length > 2 ? parts.slice(2).join('.') : undefined;
};

const getGaSessionId = (): string | undefined => {
  const cookies: Record<string, string> = Cookies.get();
  const name = cookies[GA_SESSION_COOKIE]
    ? GA_SESSION_COOKIE
    : Object.keys(cookies).find(key => GA_SESSION_COOKIE_PATTERN.test(key));
  const match = name ? GA_SESSION_ID_PATTERN.exec(cookies[name]) : null;
  return match ? match[1] : undefined;
};

// _fbc ставить Meta Pixel. Якщо його ще немає — беремо fbc_lnd, який пише наш
// скрипт у тому ж форматі fb.1.<timestamp>.<fbclid>.
const getFbc = (): string | undefined =>
  getCookie('_fbc') || getCookie('fbc_lnd');

// IP беремо з відповіді геолокації, яку застосунок уже запитує для визначення
// країни (див. doGetUserCountry). Авторитетним значенням має бути IP запиту на
// стороні accounts API — клієнтське можна підмінити.
const getUserIp = (): string | undefined => {
  try {
    const ipData = sessionStorage.getItem('ipData');
    return ipData ? JSON.parse(ipData).ip_address || undefined : undefined;
  } catch (e) {
    return undefined;
  }
};

// Дані джерела трафіку для запису в CRM у момент реєстрації.
// Порожні значення не відправляємо.
export const getTrafficSourcePayload = (): Record<string, string> => {
  const payload: Record<string, string> = {};

  const add = (field: string, value?: string) => {
    if (!isEmpty(value)) {
      payload[field] = value as string;
    }
  };

  TRAFFIC_SOURCE_COOKIES.forEach(name => add(name, getCookie(name)));

  add('ga_client_id', getGaClientId());
  add('ga_session_id', getGaSessionId());
  add('_fbp', getCookie('_fbp'));
  add('_fbc', getFbc());
  add('user_ip', getUserIp());
  add('user_agent', navigator.userAgent);

  return payload;
};
